// extracted by mini-css-extract-plugin
export default {"middleDotSeparator":"MiddleDotSeparator__middleDotSeparator__F4SxW"};